import { render, staticRenderFns } from "./PercentageGraph.vue?vue&type=template&id=88096226&"
import script from "./PercentageGraph.vue?vue&type=script&lang=js&"
export * from "./PercentageGraph.vue?vue&type=script&lang=js&"
import style0 from "./PercentageGraph.vue?vue&type=style&index=0&id=88096226&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports